var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12889_12120)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12889_12120",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 2.625C1.875 2.32663 1.99353 2.04048 2.2045 1.8295C2.41548 1.61853 2.70163 1.5 3 1.5H12C12.2984 1.5 12.5845 1.61853 12.7955 1.8295C13.0065 2.04048 13.125 2.32663 13.125 2.625V16.5H3C2.70163 16.5 2.41548 16.3815 2.2045 16.1705C1.99353 15.9595 1.875 15.6734 1.875 15.375V2.625Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 9C13.125 8.80109 13.204 8.61032 13.3447 8.46967C13.4853 8.32902 13.6761 8.25 13.875 8.25H15.375C15.5739 8.25 15.7647 8.32902 15.9053 8.46967C16.046 8.61032 16.125 8.80109 16.125 9V15.375C16.125 15.6734 16.0065 15.9595 15.7955 16.1705C15.5845 16.3815 15.2984 16.5 15 16.5H13.125V9Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 4.5H7.125M4.125 7.125H8.625",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12889_12120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0V0Z",
    fill: "#253837"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12889_12120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon-report.ff81bc54bd1b4c5d4eed782faff301c3.svg";
export { ForwardRef as ReactComponent };